module.exports = __webpack_public_path__ + "img/GHS07.5158dce4.gif";